export const setCurrentSession = (payload: any) : any => {
    return {
        type: 'SET_CURRENT_SESSION',
        payload
    };
};